import { FC } from 'react';
import { helpers } from 'src/services';
import { typeMeeting } from '@monorepo/models';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    content: React.ReactNode;
    meeting: typeMeeting;
};

export const NotificationsAssignmentsMeetings: FC<propsType> = ({ content, meeting }) => {
    const isDarkMode = useGetIsDarkMode();

    return (
        <div className={`${isDarkMode ? 'bg-dark' : ''} border rounded p-3 my-4`}>
            <h5 className={'text-center border-bottom pb-3 mb-4'}>
                REUNIÓN DEL {helpers.GetDayOfWeekFromDateString(meeting.date)?.toUpperCase()} {meeting.date}
            </h5>
            {content}
        </div>
    );
}
